import {
  getInstrumentDisplayName,
  isGeneratedIdPrimaryInstrumentType,
  isTextPrimaryInstrumentType,
} from './instrumentTypes';

type IdentityLike = {
  instrument_text?: string | null;
  generated_id?: string | null;
  instrument_type?: string | null;
};

function clean(value: string | null | undefined): string {
  return (value || '').trim();
}

export function hasManualInstrumentTag(inst: IdentityLike): boolean {
  return Boolean(clean(inst.instrument_text));
}

export function getInstrumentPrimaryLabel(inst: IdentityLike): string {
  const instrumentText = clean(inst.instrument_text);
  const generatedId = clean(inst.generated_id);
  const instrumentType = clean(inst.instrument_type);

  if (isGeneratedIdPrimaryInstrumentType(instrumentType)) {
    return generatedId || instrumentText || getInstrumentDisplayName(instrumentType) || 'Unnamed instrument';
  }

  if (isTextPrimaryInstrumentType(instrumentType)) {
    return instrumentText || generatedId || getInstrumentDisplayName(instrumentType) || 'Unnamed instrument';
  }

  return instrumentText || generatedId || getInstrumentDisplayName(instrumentType) || 'Unnamed instrument';
}

export function getInstrumentSecondaryLabel(_inst: IdentityLike): string | null {
  return null;
}

export function usesGeneratedIdAsPrimaryLabel(inst: IdentityLike): boolean {
  const instrumentText = clean(inst.instrument_text);
  const generatedId = clean(inst.generated_id);
  const instrumentType = clean(inst.instrument_type);

  if (!generatedId) return false;
  if (isGeneratedIdPrimaryInstrumentType(instrumentType)) return true;
  if (isTextPrimaryInstrumentType(instrumentType)) return !instrumentText;
  return !instrumentText;
}

export function formatInstrumentIdentity(inst: IdentityLike): string {
  return getInstrumentPrimaryLabel(inst);
}
